import React from 'react'
import {
  SiHtml5, SiCss3, SiJavascript, SiReact, SiFlutter, SiBootstrap,
  SiPython, SiNodedotjs,
  SiMysql, SiMongodb, SiFirebase,
  SiGit, SiGithub, SiC, SiCplusplus
} from 'react-icons/si'
import { FaJava } from 'react-icons/fa'
// import { TbSql } from 'react-icons/tb'

const SkillCategory = ({ title, skills }) => (
  <div className="mb-12">
    <h3 className="text-2xl font-semibold mb-6 text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
      {title}
    </h3>
    <div className="flex flex-wrap justify-center gap-6">
      {skills.map((skill, index) => (
        <div
          key={index}
          className="group flex flex-col items-center justify-center p-6 w-32 h-32
                     bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl
                     transition-all duration-300 hover:scale-110 hover:bg-white/10
                     hover:shadow-[0_0_20px_rgba(142,45,226,0.3)]"
        >
          <div className="text-4xl mb-3 text-gray-300 group-hover:text-white transition-colors duration-300">
            {skill.icon}
          </div>
          <span className="text-sm font-medium text-gray-400 group-hover:text-white transition-colors duration-300">
            {skill.name}
          </span>
        </div>
      ))}
    </div>
  </div>
);

const MySkills = () => {
  const categories = [
    {
      title: "Frontend Development",
      skills: [
        { name: "React", icon: <SiReact className="text-[#61DAFB]" /> },
        { name: "JavaScript", icon: <SiJavascript className="text-[#F7DF1E]" /> },
        { name: "HTML5", icon: <SiHtml5 className="text-[#E34F26]" /> },
        { name: "CSS3", icon: <SiCss3 className="text-[#1572B6]" /> },
        { name: "Flutter", icon: <SiFlutter className="text-[#02569B]" /> },
        { name: "Bootstrap", icon: <SiBootstrap className="text-[#7952B3]" /> },
      ]
    },
    {
      title: "Backend & Languages",
      skills: [
        { name: "Node.js", icon: <SiNodedotjs className="text-[#339933]" /> },
        { name: "Java", icon: <FaJava className="text-[#007396]" /> },
        { name: "Python", icon: <SiPython className="text-[#3776AB]" /> },
        { name: "C++", icon: <SiCplusplus className="text-[#00599C]" /> },
        { name: "C", icon: <SiC className="text-[#A8B9CC]" /> },
      ]
    },
    {
      title: "Database & Cloud",
      skills: [
        { name: "MongoDB", icon: <SiMongodb className="text-[#47A248]" /> },
        { name: "MySQL", icon: <SiMysql className="text-[#4479A1]" /> },
        { name: "Firebase", icon: <SiFirebase className="text-[#FFCA28]" /> },
      ]
    },
    {
      title: "Tools & Version Control",
      skills: [
        { name: "Git", icon: <SiGit className="text-[#F05032]" /> },
        { name: "GitHub", icon: <SiGithub className="text-white" /> },
      ]
    }
  ];

  return (
    <div className="pt-24 pb-12 px-4 min-h-screen text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 font-serif bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600 inline-block">
            Technical Arsenal
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full"></div>
          <p className="mt-4 text-xl text-gray-400"> Technologies I use to bring ideas to life</p>
        </div>

        <div className="space-y-4">
          {categories.map((category, index) => (
            <SkillCategory
              key={index}
              title={category.title}
              skills={category.skills}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default MySkills



